package org.hs_soft.runmynesto.domain.model.home.template.tabs.tab_checkout.update_template_checkout


import CashAssist
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class Data(
    @SerialName("cashAssist")
    val cashAssist: CashAssist
)